module.exports = __webpack_public_path__ + "static/media/blood-sugar.5ea8808f.svg";